import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Badge,
  Well
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import isEmpty from "lodash.isempty";

import {getSiteStatus}    from '../../../redux/actions/siteActions';

import {
  currentDealList
} from "../../../redux/actions/frontActions";

import {
  getMenuList,
  getCartDetail,
  userLogout,
  getSiteCity
} from "../../../redux/actions/frontActions";
import siteLogo from "../../../img/ddb-logo.png";
import bannerImg from "../../../img/2006380_YyczUn.png";
import noImg from "../../../img/no_img.jpg";
import dealImg from "../../../img/Deal-Photo.jpg";
import './Header.css'

let rand = require("random-key");

import Cookies from "universal-cookie";

const cookies = new Cookies();

const history = createHashHistory();
class FrontHeader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      search: "",
      themeData: {},
      menuStyles: {},
      topMenuStyles:{},
      headerStyles:{},
      menuBgStyles: {},
      cityList:[],
      default_city: "",
      notifications: "",
      width: 0, 
      height: 0,
      nearestLocation: false,
      search_deals: 'off',
      search_location: 'off',
      hover: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.logout = this.logout.bind(this);
    this.handleSearchText = this.handleSearchText.bind(this);
    this.setDefaultCity = this.setDefaultCity.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  logout = () => {
    this.props.userLogout();
  }

  setDefaultCity = (e) => {
    if(e.target.value){
      // sessionStorage.setItem('defaultCity', e.target.value);
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("cityID", e.target.value, { path: "/", expires: d });

      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      siteData.default_city = e.target.value;
      localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
      this.setState({
        default_city: e.target.value
      });
      this.props.getSiteStatus( e.target.value);
      this.props.updateSiteProperties(e.target.value);
      history.push(`/city-deal/${e.target.value}`);
    }
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page,
      cartTotal: 0
    });

    this.props.getCartDetail({'userKey':cookies.get('token')});
  };

  handleSearchText(e){
    this.setState({[e.target.name]:e.target.value});
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearch(e) {
    if (this.state.search && this.state.search.length > 0) {
      history.push(`/search-deal/${this.state.search}`);
    }
  }

  componentDidMount() {

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          search_location: siteData.search_location,
          search_deals: siteData.search_deals,
        });
      }
    }else{
        this.props.getSiteStatus();     
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.handlePageChange(1);
    if(isEmpty(this.props.menuList)){
      this.props.getMenuList({page:1});
    }
    this.props.getSiteCity();


    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData
      });

      if (this.props.themeData.favicon) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = (this.props.themeData.favicon) ? this.props.themeData.favicon : 'PayVibe';
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuStyles: {
            color: this.props.themeData.menu_bar.menu_bar_text
          },
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          },
          topMenuStyles: {
            backgroundColor: this.props.themeData.menu_bar.top_menu_bar
          },
          menuTopStyles:{
            color: this.props.themeData.menu_bar.top_menu_bar
          }
        });
      }else{
        this.setState({
          menuStyles: {
            color: ''
          },
          menuBgStyles: {
            backgroundColor: ''
          },
          topMenuStyles: {
            backgroundColor: ''
          },
          menuTopStyles:{
            color: ''
          }
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

      if (this.props.themeData.header) {
        this.setState({
          headerStyles: {
            backgroundColor: this.props.themeData.header
          }
        });
      }else{
        this.setState({
          headerStyles: {
            backgroundColor: '',
          }
        });
      }
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillReceiveProps(nextProps) { 
    if(this.props.currentCityID != nextProps.currentCityID && this.state.nearestLocation == true){
      if(nextProps.currentCityID){
        this.setState({default_city: nextProps.currentCityID.data.requested_city, nearestLocation: false})
        this.props.getSiteStatus( nextProps.currentCityID.data.requested_city );
        // history.push(`/city-deal/${nextProps.currentCityID.data.requested_city}`);        
      }
    }

    if(this.props.siteStatus != nextProps.siteStatus){
      if(nextProps.siteStatus){
        if(this.state.default_city === nextProps.siteStatus.default_city){
          this.setState({
            default_city: (this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city,
            notifications: nextProps.siteStatus.notifications,
          });
        }else{
          this.setState({
            default_city: (this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city,
            notifications: this.state.notifications,
          });
        }
        this.props.updateSiteProperties((this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city);
      }
    }

    if (nextProps.themeData) {
      this.setState({
        themeData: nextProps.themeData
      });

      if (nextProps.themeData.favicon) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = (nextProps.themeData.favicon) ? nextProps.themeData.favicon : 'PayVibe';
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      if (nextProps.themeData.menu_bar) {
        this.setState({
          menuStyles: {
            color: nextProps.themeData.menu_bar.menu_bar_text
          },
          menuBgStyles: {
            backgroundColor: nextProps.themeData.menu_bar.menu_bar_color
          },
          topMenuStyles: {
            backgroundColor: nextProps.themeData.menu_bar.top_menu_bar
          },
          menuTopStyles:{
            color: nextProps.themeData.menu_bar.top_menu_bar
          }
        });

        // document.getElementById("basic-nav-dropdown").setAttribute("style", "font-size: 100px; font-style: italic; color:#000;");;
      }else{
        this.setState({
          menuStyles: {
            color: ''
          },
          menuBgStyles: {
            backgroundColor: ''
          },
          topMenuStyles: {
            backgroundColor: ''
          },
          menuTopStyles:{
            color: ''
          }
        });
      }

      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

      if (nextProps.themeData.header) {
        this.setState({
          headerStyles: {
            backgroundColor: nextProps.themeData.header
          }
        });
      }else{
        this.setState({
          headerStyles: {
            backgroundColor: '',
          }
        });
      }
    }
    if (nextProps.menuList) {
      this.setState({ menuList: nextProps.menuList });
    }

    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        let total = 0;
        nextProps.cartDetail.data.data.map((cart, index) => (total += cart.quantity));
        this.setState({ cartTotal: total });
      }
    }

    // update cart status
    if (this.props.cartStatus != nextProps.cartStatus) {
      if (
        nextProps.cartStatus &&
        nextProps.cartStatus.userKey == cookies.get("token")
      ) {
        this.props.getCartDetail({ userKey: cookies.get("token") });
      }
    }

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  displayLogo() {
    if (this.state.themeData.logo && this.state.themeData.logo != "") {
      return this.state.themeData.logo;
    } else {
      return siteLogo;
    }
  }

  setTitle(title){
    return (<span style={ this.state.menuStyles }>{title}</span>)
  }
  findNearestCity = () => {
   
   const postData = {
      page: 1,
      latitude: "26.846695",
      longitude: "80.946167",
      limit: 10,
      cityID: this.state.default_city,
      force_geolocation : 'yes',
    };
    this.setState({nearestLocation: true});
    this.props.currentDealList(postData);
  }
  render() {
    const { index, direction, default_city} = this.state;
    let menu;

    if (!isEmpty(this.props.menuList)) {
      menu = this.props.menuList.map(
        (cat, index) =>
          !isEmpty(cat.sub_category) ? (
            <NavDropdown
              key={Math.random() + index}
              title={this.setTitle(cat.parentcatName)}
              id="basic-nav-dropdown"
              style={{color: 'red !important'}}
            >
              {cat.sub_category.map((subcat, index) => (
                <MenuItem
                  key={Math.random()}
                  onClick={() =>
                    history.push(`/all-deal/${subcat.catPermalink}`)
                  }
                  replace="true"
                >
                  <span style={this.state.menuStyles}>{subcat.catName}</span>
                </MenuItem>
              ))}
            </NavDropdown>
          ) : (
            <NavItem
              style={this.state.menuStyles}
              key={Math.random()}
              onClick={() =>
                history.push(`/all-deal/${cat.parentcatPermalink}`)
              }
              replace="true"
            >
              <span style={this.state.menuStyles}> {cat.parentcatName} </span>
            </NavItem>
          )
      );
    }
    
    return (
      <div style={this.state.headerStyles}>
        <div className="top-menu" style={this.state.headerStyles}>
          <div className="container">
            <Row>
              <Col lg={3} md={8} sm={12}>
                <div className="Co-logo">
                  <a href="#"><Image src={this.displayLogo()} /></a>
                </div>
              </Col>
              <Col lg={9} md={4} sm={12}>
                <div className="top-item">
                  <ListGroup className="topmenu">
                    <ListGroupItem style={this.state.topMenuStyles}>
                      <Link to={"/cart"} replace style={this.state.menuTopStyles}>
                        <i className="fa fa-shopping-cart" /> Cart{" "}
                        {this.state.cartTotal ? (
                          <Badge bsStyle="danger">{this.state.cartTotal}</Badge>
                        ) : null}
                      </Link>
                    </ListGroupItem>
                    {localStorage.getItem("user") ? (
                      <ListGroupItem style={this.state.topMenuStyles}>
                        <Link
                          to=""
                          replace
                          onClick={this.logout}
                          style={this.state.menuTopStyles}
                        >
                          <i className="fa fa-user" /> Logout
                        </Link>
                      </ListGroupItem>
                    ) : (
                      <ListGroupItem style={this.state.topMenuStyles}>
                        <Link to={"/login"} replace style={this.state.menuTopStyles}>
                          <i className="fa fa-user" /> Login
                        </Link>
                      </ListGroupItem>
                    )}
                    <ListGroupItem style={this.state.topMenuStyles}>
                        <Link to={"/order/status"} replace style={this.state.menuTopStyles}>
                          <i className="fa fa-cogs" /> Where's My Order
                        </Link>
                    </ListGroupItem>
                    {localStorage.getItem("user") ? (
                      <ListGroupItem style={this.state.topMenuStyles}>
                        <Link to={"/my-account"} replace style={this.state.menuTopStyles}>
                          <i className="fa fa-cog" /> My Account
                        </Link>
                      </ListGroupItem>
                    ) : (
                      <ListGroupItem style={this.state.topMenuStyles}>
                        <Link to={"/register"} replace style={this.state.menuTopStyles}>
                          <i className="fa fa-user-plus" /> Register
                        </Link>
                      </ListGroupItem>
                    )}
                  </ListGroup>
                </div>
                <div className="top-item">
                  <Row>
                    <Col xs={12} sm={6} md={6} style={{ display: (this.state.width <= 720 && this.state.search_deals == 'off') ? "none" : "block" }}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl
                            type="text"
                            name="search"
                            value={this.state.search}
                            onChange={this.handleSearchText}
                            placeholder="Search Deal"
                            onKeyPress={this.handleSearchText}
                          />
                          <InputGroup.Addon 
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == "dealSearch") ? this.state.mouseover_color : this.state.button_color}}
                          data-id = {'dealSearch'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff}
                          >
                            <Glyphicon glyph="search" onClick={this.handleSearch} />
                          </InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col xs={12} sm={6} md={6} style={{ display: (this.state.width <= 720 && this.state.search_location == 'off') ? "none" : "block" }}>
                      <FormGroup>
                        <InputGroup>
                          <FormControl componentClass="select" value={this.state.default_city} placeholder="select" onChange={this.setDefaultCity}>
                            <option value="">Choose Region/City</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                <optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>
                              )
                            }
                          </FormControl>
                          <InputGroup.Addon 
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == "location") ? this.state.mouseover_color : this.state.button_color}}
                          data-id = {"location"}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff} 
                          onClick={this.findNearestCity}>
                            <Glyphicon glyph="map-marker" />
                          </InputGroup.Addon>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="menu">
          <div className="container">
            <Row>
              <Col md={12} xs={12}>
                <Navbar
                  inverse
                  collapseOnSelect
                  style={this.state.menuBgStyles}
                >
                  <Navbar.Header>
                    <Navbar.Brand>
                      <Link to={"/"} replace className="pull-right"  style={this.state.menuStyles}>
                        <i className="fa fa-home" />
                      </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                  </Navbar.Header>
                  <Navbar.Collapse>
                    <Nav>
                    {menu}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </Col>
            </Row>
          </div>
        </div>
        {(!isEmpty(this.state.notifications)) &&
        <div className="container">
          <Col md={12} xs={12} className="text-center adds">
            {this.state.notifications.map((data, index) => 
              (data.position == 'top') &&
                <React.Fragment key={data.notificationID + index}>
                {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                  (this.state.width > 480 && data.remove_image == 1) ?
                    <React.Fragment>
                      <a href={data.display_image_link} target="_blank"><Image key={Math.random() + index} src={data.displayimage} /></a>
                      <Col md={12} xs={12} className="text-center">{(data.message != '') ? ReactHtmlParser(data.message) : ''}</Col>
                    </React.Fragment>
                  :(this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                  <React.Fragment>
                    <a className="adds" href={data.display_image_link} target="_blank"><Image key={Math.random() + index} src={data.mobileappdisplay_image} /></a>
                    <Col md={12} xs={12} className="text-center">{(data.message != '') ? ReactHtmlParser(data.message) : ''}</Col>
                  </React.Fragment>
                  :
                  <Well className="text-center">{(data.message != '') ? ReactHtmlParser(data.message) : ''}</Well>
                :
                  <Well className="text-center">{(data.message != '') ? ReactHtmlParser(data.message) : ''}</Well>
                }
                </React.Fragment>
            )}
          </Col>
        </div>
        }
      </div>
    );
  }
}

FrontHeader.propTypes = {
  getMenuList: PropTypes.func.isRequired,
  getCartDetail: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  menuList: state.frontReducer.menuList,
  cartDetail: state.frontReducer.cartDetail,
  cartStatus: state.frontReducer.cartStatus,
  logoutStatus: state.frontReducer.logoutStatus,
  cityList: state.frontReducer.cityList,
  siteStatus: state.siteReducer.siteStatus,
  error: state.frontReducer.error,
  currentCityID: state.frontReducer.currentCityID,
})

export default connect(mapStateToProps, {
  getMenuList,
  getCartDetail,
  userLogout,
  getSiteCity,
  getSiteStatus,
  currentDealList
})(FrontHeader);



// WEBPACK FOOTER //
// ./src/app/views/frontend/Header/Header.js